module.exports = __webpack_public_path__ + "static/media/logo.a1b80334.jpg";